// Toggle details row visibility for Amazon reports
document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll('.toggle-details');
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var detailsId = this.getAttribute('data-toggle');
      var rowId = 'details-row-' + detailsId.replace('upload-details-', '');
      var detailsRow = document.getElementById(rowId);
      if (detailsRow) {
        var isHidden = detailsRow.style.display === 'none';
        detailsRow.style.display = isHidden ? 'table-row' : 'none';
        this.textContent = isHidden ? 'Hide' : 'Details';
      }
    });
  });
});
